export default __webpack_public_path__ + "static/media/logo2.332a4a0b.svg";